import React, { useEffect, useState, useRef } from "react";
import {notification, Select } from "antd";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import LoadingEffect from "../../../components/Loading/LoadingEffect";
import {userList,getLoadBalanceData,createInvoice}  from  "../../../controllers/V1/k_winnInvoice/invoiceControllers";
import { getGeneralData } from "../../../controllers/V1/generalDataController";
import moment from "moment";
const UserListEditPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState({
    start_time : '00:00',
    end_time : '00:01'
  });
  const [ALLUSERSLIST, setAllUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [OPTIONS, setOptions] = useState([]);
  const [optionsLoading, setOptionsLoading] = useState(false);
  const [search_by, setSearchBy] = useState('');
  const handleSearchBy = (e)=>setSearchBy(e.target.value);


  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('Loading, please wait...');
 
  //End
  const [invoiceData, setInvoiceData] = useState({});


  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  const invoiceDataChange = (e) => {
    const {name} = e.target
    if(name === 'add_in_due'){
      setInvoiceData((pre)=>({
        ...pre,
        [e.target.name] : e.target.checked ? 'Y' : 'N'
      }));
    } else{
      setInvoiceData((pre)=>({
        ...pre,
        [e.target.name] : e.target.value 
      }));
    }
  } 

  // const fetchUserDue = async () => {
  //   try {
  //     const option = {
  //       type : 'single',
  //       condition : { users_oid : selectedUser._id },
  //       select : {due_amount : true}
  //     }
  //     const res = await list(option);
  //     if(res.status === true){
  //       const due = res.result
  //       setInvoiceData((pre)=>({
  //         ...pre,
  //         old_balance : due?.due_amount
  //       }))
  //     } else{
  //       setInvoiceData((pre)=>({
  //         ...pre,
  //         old_balance : 0
  //       }))
  //     }
  //   } catch (error) {
  //     setInvoiceData((pre)=>({
  //       ...pre,
  //       old_balance : 0
  //     }))
  //   }
  // }
  
  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if(!selectedUser){
        alert('Please select user');
      } else if(!ADDEDITDATA.start_date || !ADDEDITDATA.start_time){
        alert('Please choose From date and time.');
      } else if(!ADDEDITDATA.end_date || !ADDEDITDATA.end_time){
        alert('Please choose To date and time.');
      } else{
        setIsLoading(true);
        setLoadingText('Fetching transaction history, Please wait...');
        const startDate = `${ADDEDITDATA?.start_date} ${ADDEDITDATA?.start_time}`;
        const endDate = `${ADDEDITDATA?.end_date} ${ADDEDITDATA?.end_time}`;
        const options = {
          condition : {
            $or : [
              {debit_user : selectedUser?._id},
              {credit_user :selectedUser?._id}
            ],
            narration : {$in : ['Campaign Purchase','Campaign Commission','Campaign Purchase Cancel','Campaign Commission Cancel','Lotto Winner Redeem','Mobile Recharge','Mobile Recharge Failed','Mobile Recharge Success','Mobile Recharge Commission','Mobile Recharge Commission Reverse',]},

            created_at : { $gte : startDate, $lte : endDate }
          }
        }
        const res = await getLoadBalanceData(options);
        setInvoiceData((pre)=>({
          ...pre,
          user_oid : selectedUser?._id,
          user_id : selectedUser?.users_id,
          store_name : selectedUser?.store_name,
          user_name : `${selectedUser?.users_name}`,
          mobile : selectedUser?.users_mobile,
          email : selectedUser?.users_email,
          pos_number : selectedUser?.pos_number,
          old_balance : selectedUser?.due_amount,
        }));
        if(res?.status === true && res?.result?.length > 0){
          setLoadingText('Calculating data, Please wait...');
          // fetchUserDue();
          await calculateInvoiceData(res.result);
          
          setIsLoading(false);
        }else{
          setIsLoading(false);
        }
      }
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  };

  const getUsersData = async (searchText='') =>{
    try {
      let searchString = searchText;
      let store_name, users_name, users_mobile, users_email, pos_number, bind_person_name;

      if(search_by === 'store_name'){
        store_name = { $regex: searchString, $options: "i" }
      } else if(search_by === 'users_name'){
        users_name = { $regex: searchString, $options: "i" };
      } else if(search_by === 'users_mobile'){
        users_mobile = parseInt(searchString);
      } else if(search_by === 'users_email'){
        users_email = { $regex: searchString, $options: "i" };
      } else if(search_by === 'pos_number'){
        pos_number = parseInt(searchString);
      } else if(search_by === 'bind_person_name'){
        bind_person_name = { $regex: searchString, $options: "i" };
      }

      const option = {
        condition : { 
          status : "A",
          ...(store_name?{store_name:store_name}:null),
          ...(users_name?{users_name:users_name}:null),
          ...(users_mobile?{users_mobile:users_mobile}:null),
          ...(users_email?{users_email:users_email}:null),
          ...(pos_number?{pos_number:pos_number}:null),
          ...(bind_person_name?{bind_person_name:bind_person_name}:null),
          // ...(search_by === ''?{ $text : { $search: searchString } }:null),
          users_type : {$in : ['Retailer','Freelancer','Sales Person', 'Promoter']}
        },
        select : { users_type : true, users_name : true, last_name : true, users_mobile : true, users_email : true, users_mobile : true, store_name : true, area : true, bind_person_name : true, commission_percentage : true, users_id : true, pos_device_id : true, pos_number : true },
        sort : {store_name : 1}
        // limit : 50
      }
      const res = await userList(option);
      if(res.status === true){
        setAllUsersList(res?.result || []);
        // calculateTotalSales(res?.result);
      }
      setOptionsLoading(false);
    } catch (error) {
      
    }
  }

  const fetchGeneralData = async () =>{
    try {
      const res = await getGeneralData();
      if(res){
        setAddEditSata((pre)=>({
          ...pre,
          start_time : res?.invoice_start_time || '00:00',
          end_time : res?.invoice_end_time || '00:01',
        }));
      }
    } catch (error) {
    } 
  }

  useEffect(() => {
    fetchGeneralData();
    document.title = `K-Winn || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Invoice`;
  }, []);

  const debounceTimeout = useRef(null);

  const handleSearch = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      if (value.trim() !== "" && value.length > 3) {
        getUsersData(value);
      }
    }, 500); 
  };

  useEffect(()=>{
    if(ALLUSERSLIST.length > 0){
      const transformedArray = ALLUSERSLIST.map(user => ({
        label: `${user.users_name} | ${user.store_name} | ${user.users_mobile}`,
        value: JSON.stringify(user) 
      }));
      setOptions(transformedArray);
    }
  },[ALLUSERSLIST]);

  const handleUserChange = (value) =>{
    try {
      setSelectedUser(JSON.parse(value));
    } catch (error) {
      
    }
  }
/*********** Calculate Total Sales Amount ******* */
  const calculateInvoiceData = (data) => {
    try {
      if (data.length === 0) return;
      //Lotto Summery
      const result = data.reduce(
        (acc, item) => {
          //Lotto
            if (item.narration === "Campaign Purchase") {
                acc.orderSum += item.points || 0;
            } else if (item.narration === "Campaign Purchase Cancel") {
                acc.cancelledSum += item.points || 0;
            } else if(item.narration === 'Campaign Commission'){
                acc.commissionSum += parseFloat(item.points) || 0;
            } else if(item.narration === 'Campaign Commission Cancel'){
                acc.commissionRevertedSum += parseFloat(item.points) || 0;
            } else if(item.narration === 'Lotto Winner Redeem'){
              acc.paidSum += parseFloat(item.points) || 0;
            }
            //Raffle
            else if(item.narration === "Mobile Recharge" || item.narration === "Mobile Recharge Success"){
              acc.rechargeOrdSum += item.points || 0;
            } else if(item.narration === "Mobile Recharge Failed"){
              acc.rechargeCancelSum += item.points || 0;
            } else if(item.narration === "Mobile Recharge Commission"){
              acc.rechargeCommissionSum += item.points || 0;
            } else if(item.narration === "Mobile Recharge Commission Reverse"){
              acc.rechargeCommissionReverse += item.points || 0;
            }

            return acc;
        },
        { 
          orderSum: 0, cancelledSum: 0, commissionSum : 0, commissionRevertedSum:0, paidSum : 0,
          rechargeOrdSum : 0, rechargeCancelSum : 0, rechargeCommissionSum : 0, rechargeCommissionReverse : 0, rechargePaidSum : 0, 
        }
      );
      const totalLottoSales = parseFloat(result.orderSum) - parseFloat(result.cancelledSum);
      const totalLottoCommission = parseFloat(result.commissionSum) - parseFloat(result.commissionRevertedSum);

      
      //Raffle
      const totalRechargeSales = parseFloat(result.rechargeOrdSum) - parseFloat(result.rechargeCancelSum);
      const totalRechargeCommission = parseFloat(result.rechargeCommissionSum) - parseFloat(result.rechargeCommissionReverse);
      
      //Total
      const salesAmount = totalLottoSales + totalRechargeSales;
      const commissionAmount = totalLottoCommission + totalRechargeCommission;
      const paidAmount = result?.paidSum + result?.rechargePaidSum;

      const totalDueAmount = salesAmount - commissionAmount - paidAmount;

      const subTotalDue = totalDueAmount;
      
      setInvoiceData((pre)=>({
        ...pre,
        //Lotto
        lottoTotalSales : totalLottoSales?.toFixed(2) || 0,
        lottoTotalCommission : totalLottoCommission?.toFixed(2) || 0,
        lottoPaidAmount : result?.paidSum?.toFixed(2) || 0,
        // Recharge
        rechargeTotalSales : totalRechargeSales?.toFixed(2) || 0,
        rechargeTotalCommission : totalRechargeCommission?.toFixed(2) || 0,
        rechargePaidAmount : result?.rechargePaidSum?.toFixed(2) || 0,
        //Total
        totalSales : salesAmount?.toFixed(2),
        totalCommission : commissionAmount?.toFixed(2),
        paidAmount : paidAmount?.toFixed(2),
        incentives : 0,

        totalDue : totalDueAmount,
        subTotalDue : subTotalDue
      }))



    } catch (error) {
      console.log('error',error)
    }
  };


useEffect(()=>{
  let salesAmount = 0;
  let commissionAmount = 0;
  let paidAmount = 0;
  let insensitiveAmount = 0;

  let totalDueAmount = 0;
  let subTotalDue = 0;
  let total_debit = 0;

  if(parseFloat(invoiceData?.lottoTotalSales) > 0) salesAmount += parseFloat(invoiceData?.lottoTotalSales);
  if(parseFloat(invoiceData?.lottoTotalCommission) > 0) commissionAmount += parseFloat(invoiceData?.lottoTotalCommission);
  if(parseFloat(invoiceData?.lottoPaidAmount) > 0) paidAmount += parseFloat(invoiceData?.lottoPaidAmount);
  if(parseFloat(invoiceData?.lottoIncentives) > 0) insensitiveAmount += parseFloat(invoiceData?.lottoIncentives);


  if(parseFloat(invoiceData?.rechargeTotalSales) > 0) salesAmount += parseFloat(invoiceData?.rechargeTotalSales);
  if(parseFloat(invoiceData?.rechargeTotalCommission) > 0) commissionAmount += parseFloat(invoiceData?.rechargeTotalCommission);
  if(parseFloat(invoiceData?.rechargePaidAmount) > 0) paidAmount += parseFloat(invoiceData?.rechargePaidAmount);
  if(parseFloat(invoiceData?.rechargeIncentives) > 0) insensitiveAmount += parseFloat(invoiceData?.rechargeIncentives);

  
  total_debit = commissionAmount + paidAmount;
  
  totalDueAmount += parseFloat(salesAmount) 
  totalDueAmount -= parseFloat(total_debit) 
  totalDueAmount -= parseFloat(insensitiveAmount);
  
  
  subTotalDue += parseFloat(totalDueAmount);

  const old_balance = invoiceData?.old_balance || 0;
  const other_charges = invoiceData?.other_charges || 0;
  subTotalDue += parseFloat(old_balance);
  subTotalDue += parseFloat(other_charges);

  setInvoiceData((pre)=>({
    ...pre,
    totalSales : salesAmount?.toFixed(2),
    totalCommission : commissionAmount?.toFixed(2),
    paidAmount : paidAmount?.toFixed(2),
    incentives : parseFloat(insensitiveAmount)?.toFixed(2) || 0,

    totalDue : totalDueAmount,
    subTotalDue : subTotalDue
  }))

},[
  invoiceData?.lottoTotalSales, invoiceData?.lottoTotalCommission, invoiceData?.lottoPaidAmount, 
  invoiceData?.rechargeTotalSales, invoiceData?.rechargeTotalCommission, invoiceData?.rechargeIncentives, 
  invoiceData?.old_balance, invoiceData?.other_charges 
]);

const handlePreview = (data = {})=>{
  try {
      const params = {
        invoice_no          : invoiceData?.invoice_no || data.invoice_no,
        invoice_date        : invoiceData?.invoice_date,
        
        users_id            : selectedUser?.users_id,
        users_oid           : selectedUser?._id,
        store               : selectedUser?.store_name,
        users_name          : `${selectedUser?.users_name} ${selectedUser?.last_name}`,
        users_mobile        : selectedUser?.users_mobile,
        sales_person_name   : selectedUser?.bind_person_name,
        area                : selectedUser?.area,
        pos_device_id       : selectedUser?.pos_device_id,
        pos_number          : selectedUser?.pos_number,
        payment_mode        : invoiceData?.payment_mode,
  
        start_date          : `${ADDEDITDATA?.start_date}`,
        end_date            : `${ADDEDITDATA?.end_date}`,

        start_time          : `${ADDEDITDATA?.start_time}`,
        end_time            : `${ADDEDITDATA?.end_time}`,

        due_date            : invoiceData?.due_date?new Date(invoiceData.due_date):'',

        lottoTotalSales     : invoiceData?.lottoTotalSales || 0,
        lottoTotalCommission : invoiceData?.lottoTotalCommission || 0,
        lottoPaidAmount     : invoiceData?.lottoPaidAmount || 0,
        lottoIncentives     : invoiceData?.lottoIncentives || 0,
        
        rechargeTotalSales    : invoiceData?.rechargeTotalSales || 0,
        rechargeTotalCommission : invoiceData?.rechargeTotalCommission || 0,
        rechargePaidAmount    : invoiceData?.rechargePaidAmount || 0,
        rechargeIncentives     : invoiceData?.rechargeIncentives || 0,
  
        total_sales         : invoiceData?.totalSales,
        total_commission    : invoiceData?.totalCommission,
        total_paid          : invoiceData?.paidAmount?invoiceData.paidAmount:0,
        total_incentives    : invoiceData?.incentives,
        total_due           : invoiceData?.totalDue,
  
        old_pending_balance : invoiceData?.old_balance || 0,
        other_charges       : invoiceData?.other_charges || 0,
        sub_total_due       : invoiceData?.subTotalDue,
  
      }
      
      const {
        store,users_name, pos_number, users_mobile, invoice_date, invoice_no, payment_mode, start_date, end_date, start_time, end_time, sales_person_name, area,

        lottoTotalSales, lottoTotalCommission, lottoPaidAmount, lottoIncentives,
        rechargeTotalSales, rechargeTotalCommission, rechargePaidAmount, rechargeIncentives,
 
        sub_total_due, total_incentives, 

        total_sales, total_commission, total_paid, total_due, 
        
        other_charges, old_pending_balance, 
       } = params;
     
      let previewURL = `/invoice/preview?`
      previewURL    +=  `autoDownload=N`
      previewURL    +=  `&store_name=${store}`
      previewURL    +=  `&user_name=${users_name}`
      previewURL    +=  `&pos_number=${pos_number}`
      previewURL    +=  `&mobile=${users_mobile}`
      previewURL    +=  `&totalSales=${total_sales}`
      previewURL    +=  `&totalCommission=${total_commission}`
      previewURL    +=  `&paidAmount=${total_paid}`
      previewURL    +=  `&totalDue=${total_due}`
      previewURL    +=  `&other_charges=${other_charges}`
      previewURL    +=  `&old_balance=${old_pending_balance}`
      previewURL    +=  `&subTotalDue=${sub_total_due}`
      previewURL    +=  `&incentives=${total_incentives}`
      previewURL    +=  `&invoice_date=${invoice_date || moment().format('YYYY-MM-DD')}`
      previewURL    +=  `&invoice_no=${invoice_no || 100}`
      previewURL    +=  `&payment_mode=${payment_mode || 'Cash'}`
      previewURL    +=  `&start_date=${start_date}`
      previewURL    +=  `&end_date=${end_date}`
      previewURL    +=  `&start_time=${start_time}`
      previewURL    +=  `&end_time=${end_time}`
      previewURL    +=  `&sales_person_name=${sales_person_name}`
      previewURL    +=  `&area=${area}`

      previewURL    +=  `&lottoTotalSales=${lottoTotalSales}`
      previewURL    +=  `&lottoTotalCommission=${lottoTotalCommission}`
      previewURL    +=  `&lottoPaidAmount=${lottoPaidAmount}`
      previewURL    +=  `&lottoIncentives=${lottoIncentives}`

      previewURL    +=  `&rechargeTotalSales=${rechargeTotalSales}`
      previewURL    +=  `&rechargeTotalCommission=${rechargeTotalCommission}`
      previewURL    +=  `&rechargePaidAmount=${rechargePaidAmount}`
      previewURL    +=  `&rechargeIncentives=${rechargeIncentives}`
      
      window.open(previewURL, '_blank');
  } catch (error) {
    alert('Invoice data not fount');
  }
}

const handleGenerate = async () => {
  try {
    if(!selectedUser?.pos_number){
      notification.open({
        message: "Oops!.",
        description: `User not found!`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    } else{
      setLoadingText('Please wait your request is in process.')
      setIsLoading(true);
      const params = {
        ...(invoiceData?.invoice_no && {invoice_no          : invoiceData?.invoice_no}),
        invoice_date        : invoiceData?.invoice_date || moment().format('YYYY-MM-DD'),
        
        users_id            : selectedUser?.users_id,
        users_oid           : selectedUser?._id,
        store               : selectedUser?.store_name,
        users_name          : `${selectedUser?.users_name} ${selectedUser?.last_name}`,
        users_mobile        : selectedUser?.users_mobile,
        area                : selectedUser?.area?selectedUser.area:'N/A',
        sales_person_name   : selectedUser?.bind_person_name?selectedUser.bind_person_name:'N/A',      
        pos_device_id       : selectedUser?.pos_device_id,
        pos_number          : selectedUser?.pos_number,
        payment_mode        : invoiceData?.payment_mode,
        add_in_due          : invoiceData?.add_in_due || 'N',
  
        start_date          : `${ADDEDITDATA?.start_date} ${ADDEDITDATA?.start_time}`,
        start_time          : ADDEDITDATA?.start_time,
        end_date            : `${ADDEDITDATA?.end_date} ${ADDEDITDATA?.end_time}`,
        end_time            : ADDEDITDATA?.end_time,
        due_date            : invoiceData?.due_date || '',
        
        lottoTotalSales     : invoiceData?.lottoTotalSales || 0,
        lottoTotalCommission : invoiceData?.lottoTotalCommission || 0,
        lottoPaidAmount     : invoiceData?.lottoPaidAmount || 0,
        lottoIncentives     : invoiceData?.lottoIncentives || 0,
        
        rechargeTotalSales    : invoiceData?.rechargeTotalSales || 0,
        rechargeTotalCommission : invoiceData?.rechargeTotalCommission || 0,
        rechargePaidAmount    : invoiceData?.rechargePaidAmount || 0,
        rechargeIncentives     : invoiceData?.rechargeIncentives || 0,
  
        total_sales         : invoiceData?.totalSales,
        total_commission    : invoiceData?.totalCommission,
        total_paid          : invoiceData?.paidAmount?invoiceData.paidAmount:0,
        total_incentives    : invoiceData?.incentives,
        total_due           : invoiceData?.totalDue,
  
        old_pending_balance : invoiceData?.old_balance,
        other_charges       : invoiceData?.other_charges,
        sub_total_due       : invoiceData?.subTotalDue,
      }
      // console.log('params : ',params);
      // return;
      const res = await createInvoice(params);
      if(res.status === true){
        notification.open({
          message: "Success.",
          description: `Invoice generated Successfully.`,
          placement: "topRight",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
        handlePreview(res.result);
        navigate('/invoice/list');
      } else{
        notification.open({
          message: "Oops!.",
          description: `${res.message}`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    }
    setIsLoading(false);
  } catch (error) {
    setIsLoading(false);
  }
}
  
  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading"> Generate Invoice </h5>
          </React.Fragment>
          <Link to="/invoice/list">
            <React.Fragment>
              <button type="button" className="btn btn-secondary"> <ArrowLeftOutlined /> Back </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet" onSubmit={handleSubmit}>
                <div className="row ">
                  <div className="row">
                    {/* Search By */}
                    <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="admin_first_name" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Customer/Retailer's store :{" "}
                      </label>
                      <select title="Choose your option" name="search_by" id="search_by" className="form-control store_input_field" onChange={handleSearchBy}>
                        <option value="" selected disabled>Choose your option</option>
                        <option value="store_name">Store name</option>
                        <option value="users_name">Users name</option>
                        <option value="users_mobile">Users mobile</option>
                        <option value="users_email">Users email</option>
                        <option value="pos_number">POS No.</option>
                        <option value="bind_person_name">Bind person name</option>
                      </select>
                    </div>

                    <div className="form-group col-lg-8 col-md-8 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="admin_first_name"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>Customer/Retailer :{" "}
                      </label>
                      <Select
                       className="form-control"
                       onSearch={handleSearch}
                       onChange={handleUserChange}
                       showSearch={true}
                       defaultOpen={true}
                       autoClearSearchValue={false}
                       placeholder="Search to Select"
                       notFoundContent={null}
                       loading={optionsLoading}
                       options={OPTIONS}
                      />
                      {error.admin_first_name ? (
                        <p style={{ color: "red" }}>{error.admin_first_name}</p>
                      ) : (
                        ""
                      )}
                    </div>


                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="start_date"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>From :{" "}
                      </label>
                      <input
                        type="date"
                        name="start_date"
                        className="form-control store_input_field"
                        id="start_date"
                        onChange={handleChange}
                      />
                      {error.start_date ? (
                        <p style={{ color: "red" }}>{error.start_date}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="start_time"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        type="time"
                        name="start_time"
                        className="form-control store_input_field"
                        id="start_time"
                        value={ADDEDITDATA?.start_time}
                        onChange={handleChange}
                      />
                      {error.start_time ? (
                        <p style={{ color: "red" }}>{error.start_time}</p>
                      ) : (
                        ""
                      )}
                    </div>


                    <div className="form-group col-lg-3 col-md-3 col-sm-16 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="end_date"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>To :
                      </label> 
                      <input
                        type="date"
                        name="end_date"
                        className="form-control store_input_field"
                        id="end_date"
                        onChange={handleChange}
                      />   
                      {error.end_date ? (
                        <p style={{ color: "red" }}>{error.end_date}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        type="time"
                        name="end_time"
                        className="form-control store_input_field"
                        id="end_time"
                        value={ADDEDITDATA?.end_time}
                        onChange={handleChange}
                      />
                      {error.end_time ? (
                        <p style={{ color: "red" }}>{error.end_time}</p>
                      ) : (
                        ""
                      )}
                    </div>

                  </div>
                </div>

                <div className="inventory_edit_submit_btn">
                  <button type="submit" className="btn btn-primary inventory_save_button" > Auto Calculate </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      {/* Generate Invoice Section */}
        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              {/* <form method="post" className="inventory_form_main_contnet"> */}
                <div className="row ">
                  <div className="row">
                    {/* Store Name */}
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="admin_first_name" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Customer/Retailer's store :{" "}
                      </label>
                      <input
                        title="Customer/Retailer's Store."
                        placeholder="Customer/Retailer's store"
                        type="text"
                        name="store_name"
                        className="form-control store_input_field"
                        id="store_name"
                        value={invoiceData?.store_name || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.store_name ? ( <p style={{ color: "red" }}>{error.store_name}</p> ) : ( "" )}
                    </div>
                    
                    {/* User's Name */}
                    <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="user_name" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Name :{" "}
                      </label>
                      <input
                        title="User's Name."
                        placeholder="Customer/Retailer's name"
                        type="text"
                        name="user_name"
                        className="form-control store_input_field"
                        id="user_name"
                        value={invoiceData?.user_name || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.user_name ? ( <p style={{ color: "red" }}>{error.user_name}</p> ) : ( "" )}
                    </div>
                    {/* User's Mobile */}
                    <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="mobile" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Mobile no. :{" "}
                      </label>
                      <input
                        title="Mobile No."
                        placeholder="Mobile No."
                        type="text"
                        name="mobile"
                        className="form-control store_input_field"
                        id="mobile"
                        value={invoiceData?.mobile}
                        onChange={invoiceDataChange}
                      />
                      {error.mobile ? ( <p style={{ color: "red" }}>{error.mobile}</p> ) : ( "" )}
                    </div>
                    {/* Start Date */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="start_date"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>From :{" "}
                      </label>
                      <input
                        type="date"
                        name="start_date"
                        className="form-control store_input_field"
                        id="start_date"
                        value={ADDEDITDATA?.start_date}
                        onChange={handleChange}
                      />
                      {error.start_date ? (
                        <p style={{ color: "red" }}>{error.start_date}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* Start Time */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="start_time"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        type="time"
                        name="start_time"
                        className="form-control store_input_field"
                        id="start_time"
                        value={ADDEDITDATA?.start_time}
                        onChange={handleChange}
                      />
                      {error.start_time ? (
                        <p style={{ color: "red" }}>{error.start_time}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* End Date */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-16 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="end_date"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>To :
                      </label> 
                      <input
                        type="date"
                        name="end_date"
                        className="form-control store_input_field"
                        id="end_date"
                        value={ADDEDITDATA?.end_date}
                        onChange={handleChange}
                      />   
                      {error.end_date ? (
                        <p style={{ color: "red" }}>{error.end_date}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* End Time */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        type="time"
                        name="end_time"
                        className="form-control store_input_field"
                        id="end_time"
                        value={ADDEDITDATA?.end_time}
                        onChange={handleChange}
                      />
                      {error.end_time ? (
                        <p style={{ color: "red" }}>{error.end_time}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* Machine Ref */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="pos_number" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Machine Ref. :{" "}
                      </label>
                      <input
                        title="Machine Ref."
                        placeholder="Machine Ref"
                        type="text"
                        name="pos_number"
                        className="form-control store_input_field"
                        id="pos_number"
                        value={invoiceData?.pos_number}
                        onChange={invoiceDataChange}
                      />
                      {error.pos_number ? ( <p style={{ color: "red" }}>{error.pos_number}</p> ) : ( "" )}
                    </div>
                    {/* Invoice No. */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="invoice_no" className="all_section_for_label_main_class" >Invoice no. :</label>
                      <input
                        title="Invoice No."
                        placeholder="Invoice No."
                        type="text"
                        name="invoice_no"
                        className="form-control store_input_field"
                        id="invoice_no"
                        value={invoiceData?.invoice_no}
                        onChange={invoiceDataChange}
                      />
                      {error.invoice_no ? ( <p style={{ color: "red" }}>{error.invoice_no}</p> ) : ( "" )}
                    </div>
                    {/* Invoice Date */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="invoice_date" className="all_section_for_label_main_class" ><span style={{ color: "red" }}>*</span>Invoice date :</label>
                      <input
                        title="Invoice Date"
                        placeholder="Invoice Date"
                        type="date"
                        name="invoice_date"
                        className="form-control store_input_field"
                        id="invoice_date"
                        value={invoiceData?.invoice_date || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.invoice_date ? ( <p style={{ color: "red" }}>{error.invoice_date}</p> ) : ( "" )}
                    </div>
                    {/* payment_mode */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="payment_mode" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Mode/Terms of payment :{" "}
                      </label>
                      <select name="payment_mode" id="payment_mode" className="form-control store_input_field" onChange={invoiceDataChange} >
                        <option value='' selected disabled >Choose your options</option>
                        <option value='Cash' >Cash</option>
                        <option value='Online' >Online</option>
                      </select>
                      {error.payment_mode ? ( <p style={{ color: "red" }}>{error.payment_mode}</p> ) : ( "" )}
                    </div>

                    {/* Lotto Total Sales */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="lottoTotalSales" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Daily Draw Total Sale :{" "}
                      </label>
                      <input
                        title="Daily Draw Total Sale"
                        placeholder="Daily Draw Total Sale"
                        type="number"
                        name="lottoTotalSales"
                        className="form-control store_input_field"
                        id="lottoTotalSales"
                        value={invoiceData?.lottoTotalSales || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.lottoTotalSales ? ( <p style={{ color: "red" }}>{error.lottoTotalSales}</p> ) : ( "" )}
                    </div>

                    {/* Lotto Total Commission */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="lottoTotalCommission" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Daily Draw Total Commission :{" "}
                      </label>
                      <input
                        title="Daily Draw Total Commission"
                        placeholder="Daily Draw Total Commission"
                        type="number"
                        name="lottoTotalCommission"
                        className="form-control store_input_field"
                        id="lottoTotalCommission"
                        value={invoiceData?.lottoTotalCommission || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.lottoTotalCommission ? ( <p style={{ color: "red" }}>{error.lottoTotalCommission}</p> ) : ( "" )}
                    </div>

                    {/* Lotto Amount Paid */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="lottoPaidAmount" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Daily Draw Amount Paid :{" "}
                      </label>
                      <input
                        title="Daily Draw Amount Paid"
                        placeholder="Daily Draw Amount Paid"
                        type="number"
                        name="lottoPaidAmount"
                        className="form-control store_input_field"
                        id="lottoPaidAmount"
                        value={invoiceData?.lottoPaidAmount || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.lottoPaidAmount ? ( <p style={{ color: "red" }}>{error.lottoPaidAmount}</p> ) : ( "" )}
                    </div>

                    {/* Lotto Total Sales */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="lottoIncentives" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Daily Draw Other Incentives :{" "}
                      </label>
                      <input
                        title="Daily Draw Other Incentives"
                        placeholder="Daily Draw Other Incentives"
                        type="number"
                        name="lottoIncentives"
                        className="form-control store_input_field"
                        id="lottoIncentives"
                        value={invoiceData?.lottoIncentives || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.lottoIncentives ? ( <p style={{ color: "red" }}>{error.lottoIncentives}</p> ) : ( "" )}
                    </div>

                    {/* Raffle Total Sales */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="rechargeTotalSales" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Recharge Total Sales :{" "}
                      </label>
                      <input
                        title="Recharge Total Sale"
                        placeholder="Recharge Total Sale"
                        type="number"
                        name="rechargeTotalSales"
                        className="form-control store_input_field"
                        id="rechargeTotalSales"
                        value={invoiceData?.rechargeTotalSales || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.rechargeTotalSales ? ( <p style={{ color: "red" }}>{error.rechargeTotalSales}</p> ) : ( "" )}
                    </div>

                    {/* Raffle Total Commission */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="rechargeTotalCommission" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Recharge Total Commission :{" "}
                      </label>
                      <input
                        title="Recharge Total Commission"
                        placeholder="Recharge Total Commission"
                        type="number"
                        name="rechargeTotalCommission"
                        className="form-control store_input_field"
                        id="rechargeTotalCommission"
                        value={invoiceData?.rechargeTotalCommission || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.rechargeTotalCommission ? ( <p style={{ color: "red" }}>{error.rechargeTotalCommission}</p> ) : ( "" )}
                    </div>

                    {/* Raffle Amount Paid */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="rechargePaidAmount" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Recharge Amount Paid :{" "}
                      </label>
                      <input
                        title="Recharge Amount Paid"
                        placeholder="Recharge Amount Paid"
                        type="number"
                        name="rechargePaidAmount"
                        className="form-control store_input_field"
                        id="rechargePaidAmount"
                        value={invoiceData?.rechargePaidAmount || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.rechargePaidAmount ? ( <p style={{ color: "red" }}>{error.rechargePaidAmount}</p> ) : ( "" )}
                    </div>

                    {/* Recharge Other Incentives */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="rechargeIncentives" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Recharge Other Incentives :{" "}
                      </label>
                      <input
                        title="Recharge Other Incentives"
                        placeholder="Recharge Other Incentives"
                        type="number"
                        name="rechargeIncentives"
                        className="form-control store_input_field"
                        id="rechargeIncentives"
                        value={invoiceData?.rechargeIncentives || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.rechargeIncentives ? ( <p style={{ color: "red" }}>{error.rechargeIncentives}</p> ) : ( "" )}
                    </div>

                    <hr className="mb-0"/>

                    {/* Total Sales */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data ">
                      <label htmlFor="totalSales" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Total sale :{" "}
                      </label>
                      <input
                        title="Total Sale"
                        placeholder="Total sale"
                        type="number"
                        name="totalSales"
                        className="form-control store_input_field"
                        id="totalSales"
                        disabled
                        value={invoiceData?.totalSales || ''}
                        // onChange={invoiceDataChange}
                      />
                      {error.totalSales ? ( <p style={{ color: "red" }}>{error.totalSales}</p> ) : ( "" )}
                    </div>
                    {/* Total Commission */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="totalCommission" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Total commission :{" "}
                      </label>
                      <input
                        title="Total Commission"
                        placeholder="Total commission"
                        type="number"
                        name="totalCommission"
                        className="form-control store_input_field"
                        id="totalCommission"
                        disabled
                        value={invoiceData?.totalCommission || ''}
                        // onChange={invoiceDataChange}
                      />
                      {error.totalCommission ? ( <p style={{ color: "red" }}>{error.totalCommission}</p> ) : ( "" )}
                    </div>
                    {/* Amount Paid */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="paidAmount" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Amount paid:{" "}
                      </label>
                      <input
                        title="Amount Paid"
                        placeholder="Amount paid"
                        type="number"
                        name="paidAmount"
                        className="form-control store_input_field"
                        id="paidAmount"
                        disabled
                        value={invoiceData?.paidAmount || ''}
                        // onChange={invoiceDataChange}
                      />
                      {error.paidAmount ? ( <p style={{ color: "red" }}>{error.paidAmount}</p> ) : ( "" )}
                    </div>
                    {/* Other Incentives */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="incentives" className="all_section_for_label_main_class" > Other incentives :{" "} </label>
                      <input
                        title="Total incentives"
                        placeholder="Total incentives"
                        type="number"
                        name="incentives"
                        className="form-control store_input_field"
                        id="incentives"
                        disabled
                        value={invoiceData?.incentives || ''}
                        // onChange={invoiceDataChange}
                      />
                      {error.incentives ? ( <p style={{ color: "red" }}>{error.incentives}</p> ) : ( "" )}
                    </div>
               
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-5">
                      <h4 style={{textAlign : "left"}} className="amount_heading">Due amount : AED {invoiceData?.totalDue?.toFixed(2) || 0}</h4>
                    </div>
                    <hr className="mb-0"/>

                    {/* Old Balance */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="old_balance" className="all_section_for_label_main_class amount_heading" > Old balance pending :{" "}</label>
                      <input
                        title="Old balance pending"
                        placeholder="Old balance pending"
                        type="number"
                        name="old_balance"
                        className="form-control store_input_field"
                        id="old_balance"
                        value={invoiceData?.old_balance || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.old_balance ? ( <p style={{ color: "red" }}>{error.old_balance}</p> ) : ( "" )}
                    </div>
                    {/* Other Charges */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="other_charges" className="all_section_for_label_main_class amount_heading" > Other charges (if any) :{" "} </label>
                      <input
                        title="Other charges"
                        placeholder="Other charges"
                        type="number"
                        name="other_charges"
                        className="form-control store_input_field"
                        id="other_charges"
                        value={invoiceData?.other_charges || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.other_charges ? ( <p style={{ color: "red" }}>{error.other_charges}</p> ) : ( "" )}
                    </div>

                  
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-4 mb-2">
                      <h4 style={{textAlign : "left"}}>Total due as per statement : AED {invoiceData?.subTotalDue?.toFixed(2) || 0}</h4>
                    </div>
                    <hr/>

                    <div className="form-group col-lg-12 col-md-12 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="add_in_due" className="all_section_for_label_main_class amount_heading" >
                        <input
                        title="add_in_due"
                        type="checkbox"
                        name="add_in_due"
                        className="store_input_field"
                        id="add_in_due"
                        value={invoiceData?.add_in_due === 'Y' ? 'Y' : 'N'}
                        onChange={invoiceDataChange}
                      />
                        {`   Check to add ${invoiceData?.subTotalDue?.toFixed(2)} amount in due balance.`}
                      </label>
                      
                    </div>

                  </div>

                </div>

                <div className="inventory_edit_submit_btn mt-3">
                  <button type="button" className="btn btn-danger inventory_save_button mx-2" onClick={handlePreview} > Preview </button>
                  <button type="button" className="btn btn-primary inventory_save_button" onClick={handleGenerate} > Generate </button>
                </div>
              {/* </form> */}
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} text={loadingText} />
    </div>
  );
};

export default UserListEditPage;
